<po-page-edit
    p-title="Atualização Cadastral - Fornecedor - Aprovação"
    [p-disable-submit]="validForm()"
    [p-breadcrumb]="breadcrumb"
    (p-save)="openModalConfirmar()"
    (p-cancel)="openModalRejeitar()"
  >
    <form #formCadastroFornecedor="ngForm">
      <div class="po-row">
          <div class="po-row">
            <h1 class="po-font-subtitle">Identificação</h1>
          </div>
          <div class="po-row">
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Código/Loja" [p-value]="fornecedorDto.CCODIGOLOJA"></po-info>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="CNPJ/CPF" [p-value]="utilService.formatarCGC(fornecedorDto.fornecedor.CA2CGC)"></po-info>
            <po-input
              class="po-md-4"
              name="CA2NOME"
              [(ngModel)]="fornecedorDto.fornecedor.CA2NOME"
              p-help="{{fornecedor.CA2NOME||'-'}}"
              p-label="Razão Social (*)"
              p-required
              [p-disabled]="bloqueiaCampo"
              [p-maxlength]="40"
              [p-minlength]="5">
            </po-input>
          </div>
          <div class="po-row">
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Inscrição Estadual" [p-value]="fornecedorDto.fornecedor.CA2INSCR"></po-info>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Inscrição Municipal" [p-value]="fornecedorDto.fornecedor.CA2INSCRM"></po-info>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Natureza" [p-value]="fornecedorDto.fornecedor.CA2NATUREZ"></po-info>
          </div>
          <div class="po-lg-12">
            <h1 class="po-font-subtitle">Endereço</h1>
            <po-input
              class="po-md-2"
              name="CA2CEP"
              [(ngModel)]="fornecedorDto.fornecedor.CA2CEP"
              p-help="{{fornecedor.CA2CEP||'-'}}"
              p-label="CEP (*)"
              p-mask="99.999-999"
              p-required="true"
              [p-disabled]="bloqueiaCampo"
              (p-change)="alteraCep()"
              [p-maxlength]="10"
              [p-minlength]="10">
            </po-input>
            <po-input
              class="po-md-6"
              name="CA2END"
              [(ngModel)]="fornecedorDto.fornecedor.CA2END"
              p-help="{{fornecedor.CA2END||'-'}}"
              p-label="Logradouro (*)"
              [p-disabled]="bloqueiaCampo"
              p-required="true"
              [p-maxlength]="40"
              [p-minlength]="10">
            </po-input>
            <po-input
              class="po-md-3"
              name="CA2BAIRRO"
              [(ngModel)]="fornecedorDto.fornecedor.CA2BAIRRO"
              p-help="{{fornecedor.CA2BAIRRO||'-'}}"
              p-label="Bairro (*)"
              [p-disabled]="bloqueiaCampo"
              p-required="true"
              [p-maxlength]="30"
              [p-minlength]="0">
            </po-input>
            <po-select
              class="po-md-3"
              name="CA2EST"
              [(ngModel)]="fornecedorDto.fornecedor.CA2EST"
              p-help="{{fornecedor.CA2EST||'-'}}"
              p-label="Estado (*)"
              p-disable="true"
              [p-required]="true"
              [p-options]="listaEstado">
            </po-select>
            <po-lookup
              class="po-md-4"
              name="CA2COD_MUN"
              [(ngModel)]="fornecedorDto.fornecedor.CA2COD_MUN"
              p-help="{{fornecedor.CA2COD_MUN||'-'}}"
              p-field-label="CCC2MUN"
              p-field-value="CCC2CODMUN"
              p-label="Município IBGE (*)"
              [p-disabled]="lbloqueiaCampo"
              [p-columns]="columnsMunicipioIBGEFilters"
              [p-field-format]="fieldFormaterMunicipioIBGEFilters"
              [p-filter-service]="municipioIBGEService"
              [p-advanced-filters]="advancedMunicipioIBGEFilters"
              [p-literals]="{ modalTitle: 'MunicipioIBGE' }"
              (p-selected)="municipioIBGESelecionado($event)"
            >
            </po-lookup>
          </div>
          <div class="po-lg-12">
            <h1 class="po-font-subtitle">Contato</h1>
            <po-input
              class="po-md-2"
              name="CA2DDD"
              [(ngModel)]="fornecedorDto.fornecedor.CA2DDD"
              p-help="{{fornecedor.CA2DDD||'-'}}"
              p-label="DDD (*)"
              [p-disabled]="bloqueiaCampo"
              p-mask="999"
              p-required
              [p-maxlength]="3"
              [p-minlength]="2">
            </po-input>
            <po-input
              class="po-md-3"
              name="CA2TEL"
              [(ngModel)]="fornecedorDto.fornecedor.CA2TEL"
              p-help="{{fornecedor.CA2TEL||'-'}}"
              p-label="Telefone (*)"
              [p-disabled]="bloqueiaCampo"
              p-required
              [p-maxlength]="15"
              [p-minlength]="8">
            </po-input>
          </div>
          <div class="po-lg-12">
            <po-input
              class="po-md-3"
              name="CA2FAX"
              [(ngModel)]="fornecedorDto.fornecedor.CA2FAX"
              p-help="{{fornecedor.CA2FAX||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="FAX"
              [p-maxlength]="15"
              [p-minlength]="0">
            </po-input>
            <po-input
              class="po-md-4"
              p-icon="po-icon-mail"
              name="CA2EMAIL"
              [(ngModel)]="fornecedorDto.fornecedor.CA2EMAIL"
              p-help="{{fornecedor.CA2EMAIL||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="Email (*)"
              p-required
              p-placeholder="example@domain.com"
              [p-maxlength]="100"
              [p-minlength]="0">
            </po-input>
            <po-url
              class="po-md-4"
              name="CA2HPAGE"
              [(ngModel)]="fornecedorDto.fornecedor.CA2HPAGE"
              p-help="{{fornecedor.CA2HPAGE||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="Home Page"
              p-placeholder="www.domain.com"
              [p-maxlength]="30"
              [p-minlength]="0">
            </po-url>
          </div>
          <div class="po-lg-12">
            <h1 class="po-font-subtitle">Dados Pagamento</h1>
            <po-input
              class="po-md-2"
              name="CA2BANCO"
              [(ngModel)]="fornecedorDto.fornecedor.CA2BANCO"
              p-help="{{fornecedor.CA2BANCO||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="Banco"
              [p-minlength]="3"
              [p-maxlength]="3"
            >
            </po-input>
            <po-input
              class="po-md-2"
              name="CA2AGENCIA"
              [(ngModel)]="fornecedorDto.fornecedor.CA2AGENCIA"
              p-help="{{fornecedor.CA2AGENCIA||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="Agência"
              [p-minlength]="4"
              [p-maxlength]="4">
            </po-input>
            <!--<po-input
              class="po-md-1"
              name="CA2DVAGE"
              [(ngModel)]="fornecedorDto.fornecedor.CA2DVAGE"
              p-help="{{fornecedor.CA2DVAGE||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="DV Agencia"
              [p-maxlength]="1">
            </po-input>-->
            <po-input
              class="po-md-2"
              name="CA2NUMCON"
              [(ngModel)]="fornecedorDto.fornecedor.CA2NUMCON"
              p-help="{{fornecedor.CA2NUMCON||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="Conta"
              [p-maxlength]="10">
            </po-input>
            <!--<po-input
              class="po-md-1"
              name="CA2DVCTA"
              [(ngModel)]="fornecedorDto.fornecedor.CA2DVCTA"
              p-help="{{fornecedor.CA2DVCTA||'-'}}"
              [p-disabled]="bloqueiaCampo"
              p-label="DV Conta"
              [p-maxlength]="1">
            </po-input>-->
          </div>
            <div class="po-row po-mt-2">
              <po-textarea
                class="po-md-12"
                name="observacao"
                [(ngModel)]="observacaoEntidade"
                p-label="Observação do FORNECEDOR:"
                [p-disabled]="true"
                >
              </po-textarea>
          </div>
        </div>
      </form>
      <div class="po-lg-12">
        <po-table class="po-sm-12 po-md-12 po-lg-12"
          [p-height]="200"
          [p-hide-select-all]="true"
          [p-sort]="true"
          [p-striped]="true"
          [p-columns]="colunasHistorico"
          [p-items]="itensHistorico"
          p-spacing="small"
        ></po-table>
      </div>
      <po-modal #rejeitarModal p-title="Rejeitar Cadastro" [p-primary-action]="rejeitarCadastroAction">
        <form>
          <po-textarea
            class="po-md-12"
            name="observacao"
            [(ngModel)]="observacaoRejeicao"
            p-label="Observação sobre a Rejeição:"
          >
          </po-textarea>
        </form>
      </po-modal>
  </po-page-edit>
